module.exports = __webpack_public_path__ + "img/idea.a633fcd5.svg";